import { inject, Injectable } from '@angular/core';
import { AuthService } from '@tokenbox/services';
import { PAYMENT_CONFIG } from '../payment.config';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  private authService = inject(AuthService);
  private = inject(AuthService);

  public readonly customerPortalUrl = PAYMENT_CONFIG.billing.customerPortalUrl;

  public buildCheckoutUrlForCurrentUser(teamId: string) {
    const email = this.authService.email();
    const userId = this.authService.userId();
    if (!email || !userId) {
      return '';
    }
    return this.buildCheckoutUrl(email, teamId, userId);
  }

  private buildCheckoutUrl(email: string, teamId: string, userId: string) {
    const checkoutUrl = new URL(PAYMENT_CONFIG.checkout.url);
    checkoutUrl.searchParams.append('checkout[email]', email);
    checkoutUrl.searchParams.append('checkout[custom][teamId]', teamId);
    checkoutUrl.searchParams.append('checkout[custom][userId]', userId);
    return checkoutUrl.href;
  }
}
